module.exports = __webpack_public_path__ + "static/img/quotation_right.98b531be.svg";